import api from "@/services/api";

const methods = api.getPrefixedMethods("settings");

export const settingsService = {
  getCustomTags() {
    return methods.get("tags");
  },
  // scope is ignored by LAM-5186+ pods but a mid-rollout legacy pod 400s without it
  updateCustomTags(tags, sortOrder) {
    return methods.put("tags", { scope: "intake", tags, sortOrder });
  },
  getMyActionNeeded() {
    return methods.get("action-needed/me");
  },
  updateMyActionNeededChip(scope, showChip) {
    return methods.put("action-needed/me", { scope, showChip });
  },
  updateMyActionNeededStatuses(scope, statuses) {
    return methods.put("action-needed/me", { scope, statuses });
  },
  resetMyActionNeeded(scope) {
    return methods.delete("action-needed/me", { params: { scope } });
  },
  getMyTableColumns() {
    return methods.get("table-columns/me");
  },
  updateMyTableColumns(scope, columns) {
    return methods.put("table-columns/me", { scope, columns });
  },
  resetMyTableColumns(scope) {
    return methods.delete("table-columns/me", { params: { scope } });
  },
  getPriorAuthStatusChangeEmailsEnabled() {
    return methods.get("prior-auth-status-change-emails-enabled");
  },
  updatePriorAuthStatusChangeEmailsEnabled(enabled) {
    return methods.put("prior-auth-status-change-emails-enabled", { enabled });
  },
  getPriorAuthStatusChangeNotfStatuses() {
    return methods.get("prior-auth-status-change-notf-statuses");
  },
  updatePriorAuthStatusChangeNotfStatuses(statuses) {
    return methods.put("prior-auth-status-change-notf-statuses", { statuses });
  },
};
